/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


/* Added by Al C. Shopify Theme Support on January 16 2019 */

$(document).ready(function() {
    $('#contact_form').on('click', '[value="Send"]', function() {
      if ($('#ContactFormPhone').val().length > 9) {
        $(this).submit();
      }
      else {
        alert("You must enter a 10 digit phone number.");
        return false;
      }
    });
  });
/* End of changes by Al C. Shopify Theme Support on January 16 2019 */